import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = guest, object = logged in
  const [token, setToken] = useState(() => localStorage.getItem("nibro_admin_token") || "");

  useEffect(() => {
    // Skip the /auth/me probe when there is no stored token — otherwise we
    // generate a noisy 401 in the console on every public page load.
    if (!token) {
      setAdmin(false);
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    axios
      .get(`${API}/auth/me`, { headers, withCredentials: true })
      .then((r) => setAdmin(r.data.user))
      .catch(() => setAdmin(false));
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(
      `${API}/auth/login`,
      { email, password },
      { withCredentials: true },
    );
    const t = r.data.token;
    setToken(t);
    localStorage.setItem("nibro_admin_token", t);
    setAdmin(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (_) {}
    localStorage.removeItem("nibro_admin_token");
    setToken("");
    setAdmin(false);
  };

  const adminApi = axios.create({
    baseURL: API,
    headers: { Authorization: token ? `Bearer ${token}` : undefined },
    withCredentials: true,
  });

  return (
    <AdminContext.Provider value={{ admin, login, logout, token, adminApi }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
